// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_ex_list {
    display: flex;
    gap: 5px;
    align-items: center;

}

.table_ex_name {
    border: 1px solid #0877BC;
    border-radius: 6px;
    padding: 8px 10px;
    font-size: 13px;
    color: #0877BC;
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: #fff;
}

.selected-ex-add {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border: 2px solid #0877BC;
    border-radius: 8px;
    padding: 3px;

    img {
        width: 30px
    }
}

.table_ex_arrow {
    border: 1px solid #0877BC;
    border-radius: 6px;
    padding: 6px 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background-color: #0877BC;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/Selectedexercise.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;;AAEvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;;IAEZ;QACI;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB","sourcesContent":[".table_ex_list {\n    display: flex;\n    gap: 5px;\n    align-items: center;\n\n}\n\n.table_ex_name {\n    border: 1px solid #0877BC;\n    border-radius: 6px;\n    padding: 8px 10px;\n    font-size: 13px;\n    color: #0877BC;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    background-color: #fff;\n}\n\n.selected-ex-add {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #fff;\n    border: 2px solid #0877BC;\n    border-radius: 8px;\n    padding: 3px;\n\n    img {\n        width: 30px\n    }\n}\n\n.table_ex_arrow {\n    border: 1px solid #0877BC;\n    border-radius: 6px;\n    padding: 6px 3px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    background-color: #0877BC;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
